import React, { useState, useEffect, useContext } from "react";
import { getCurrentDate } from "../../../configs/helpers";
import { fetchedInventoryBetweenDates, fetchedProducts } from "../../../apis/apis.logistics/apisProduct";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../contexts/GlobalContext";

const initialFormDataState = {
    warehouseID: "0",
    warehouses: [],
    startDate: getCurrentDate("-"),
    endDate: getCurrentDate("-"),
    productID: "0",
};

const inputClass =
    "w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";
const labelClass = "block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1";

function FormField({ label, children }) {
    return (
        <div className="mb-4">
            <label className={labelClass}>{label}</label>
            {children}
        </div>
    );
}

export function InventoryForm(props) {
    const { setInventories, subsidiary, warehouses } = useContext(GlobalContext);
    const [formData, setFormData] = useState(initialFormDataState);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        getComparativeFromProductsOfOneWarehouse();
    }, []);

    useEffect(() => {
        if (warehouses.length) {
            setFormData((prevState) => ({
                ...prevState,
                warehouses: warehouses,
                warehouseID: warehouses[0].warehouseID,
            }));
        }
    }, [warehouses]);

    const getInventoryBetweenDates = async () => {
        try {
            const response = await fetchedInventoryBetweenDates({
                warehouseID: formData.warehouseID,
                productID: formData.productID,
                startDate: formData.startDate,
                endDate: formData.endDate,
            });
            setInventories(response);
            toast.info("Se encontraron " + response.length + " registros.");
        } catch (error) {
            throw error;
        }
    };

    const getComparativeFromProductsOfOneWarehouse = async () => {
        try {
            const response = await fetchedProducts();
            setProducts(response);
        } catch (error) {
            throw error;
        }
    };

    const handleChangeFormWarehouse = (e) => {
        setFormData({ ...formData, warehouseID: e.target.value });
        var index = e.nativeEvent.target.selectedIndex;
        props.setSelectedInventory({
            ...props.selectedInventory,
            warehouseName: e.nativeEvent.target[index].text,
        });
    };

    const handleChangeFormProduct = (e) => {
        setFormData({ ...formData, productID: e.target.value });
        const product = products.find(
            (product) => Number(product.productID) === Number(e.target.value)
        );
        if (product != null) {
            props.setSelectedInventory({
                ...props.selectedInventory,
                productName: product.saleName,
            });
        }
    };

    const handleChangeForm = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClickBtnSearch = async () => {
        if (
            new Date(formData.startDate) > new Date(formData.endDate) ||
            new Date(formData.endDate) < new Date(formData.startDate)
        ) {
            toast.error("Verificar fechas");
        } else if (Number(formData.warehouseID) <= 0) {
            toast.error("Verificar almacén");
        } else if (Number(formData.productID) <= 0) {
            toast.error("Verificar producto");
        } else {
            getInventoryBetweenDates();
        }
    };

    return (
        <div className="space-y-1">
            <FormField label="Sede">
                <select className={inputClass} name="subsidiaryID" disabled>
                    <option value={subsidiary.subsidiaryID}>
                        {subsidiary.subsidiaryName}
                    </option>
                </select>
            </FormField>

            <FormField label="Almacén">
                <select
                    className={inputClass}
                    name="warehouseID"
                    value={formData.warehouseID}
                    onChange={handleChangeFormWarehouse}
                >
                    <option value="0">Elegir</option>
                    {warehouses.map((item, index) => (
                        <option key={index} value={item.warehouseID}>
                            {item.warehouseName}
                            {item.gang?.gangName ? ` | ${item.gang.gangName}` : ""}
                        </option>
                    ))}
                </select>
            </FormField>

            <FormField label="Producto">
                <select
                    className={inputClass}
                    name="productID"
                    value={formData.productID}
                    onChange={handleChangeFormProduct}
                >
                    <option value="0">Elegir</option>
                    {products.map((item, index) => (
                        <option key={index} value={item.productID}>
                            {item.code}|{item.sku}|{item.saleName}
                        </option>
                    ))}
                </select>
            </FormField>

            <FormField label="Desde">
                <input
                    type="date"
                    className={inputClass}
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleChangeForm}
                />
            </FormField>

            <FormField label="Hasta">
                <input
                    type="date"
                    className={inputClass}
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleChangeForm}
                />
            </FormField>

            <button
                type="button"
                onClick={handleClickBtnSearch}
                className="mt-2 flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
            >
                <i className="fas fa-search" aria-hidden="true" />
                Buscar
            </button>
        </div>
    );
}
